export default __webpack_public_path__ + "static/media/1e0f3fc2209f01cfdc192e0d9354c70a1581604468211.6bc33cf6.webp";